<template>
	<div>
		<div id="id__header_in_order">
			<div class="mt-3">
				<div class="mb-4">
					<div
						v-b-toggle.collapse-education
					>
						<div class="d-flex align-items-center">
							<span class="documents-title mb-0 d-flex align-items-center">
								Образование
								<span
									v-if="!isProfile && !isRequiredVat"
									class="education-info ml-2"
									@click="show = true"
								>
									<i class="icon-info icon-icon_info" />
								</span>
								<span v-if="getVerification('education_document')" class="ml-2 text-success">
									Одобрено
								</span>
							</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsEducation
							:form="documents.education_document"
							:hide-vat-info="isRequiredVat"
						/>
					</KeepAlive>
					<b-modal
						id="education-diploma-info"
						v-model="show"
						centered
					>
						<div>
							Согласно п. 3 ст. 107 Федерального закона «Об образовании в
							Российской Федерации» в нашей
							стране признаются иностранное образование и (или)
							иностранная квалификация, подпадающие под действие
							международных договоров о взаимном признании, а также полученные
							в иностранных образовательных организациях,
							перечень которых с указанием соответствия получаемых в них образования
							и (или) квалификации образованию и (или)
							квалификации, полученным в Российской Федерации, устанавливается
							Правительством Российской Федерации на основании Распоряжения
							Правительства РФ (актуальный перечень закреплен Распоряжением
							Правительства РФ от 30.01.2023 N 186-р)
						</div>
						<template #modal-footer>
							<div class="w-100">
								<b-button
									variant="primary"
									class="float-right"
									@click="show = false"
								>
									Закрыть
								</b-button>
							</div>
						</template>
					</b-modal>
				</div>

				<div class="mb-4">
					<div
						v-b-toggle.collapse-passport
					>
						<div class="d-flex align-items-center">
							<span class="documents-title mb-0">Паспорт</span>
							<span v-if="getVerification('passport_document')" class="ml-2 text-success">
								Одобрено
							</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsPassport
							:form="documents.passport_document"
						/>
					</KeepAlive>
				</div>

				<div class="mb-4">
					<div
						v-b-toggle.collapse-changing-fio
					>
						<div class="d-flex align-items-center">
							<span class="documents-title mb-0">Документ о смене ФИО</span>
							<span v-if="getVerification('passport_document')" class="ml-2 text-success">
								Одобрено
							</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentChangeFIO
							:form="documents.document_change_surname"
						/>
					</KeepAlive>
				</div>

				<div>
					<div
						v-b-toggle.collapse-snils
					>
						<div class="d-flex align-items-center">
							<span class="documents-title mb-0">СНИЛС</span>
							<span v-if="getVerification('snils_document')" class="ml-2 text-success">
								Одобрено
							</span>
						</div>
					</div>
					<KeepAlive>
						<DocumentsSnils
							:form="documents.snils_document"
						/>
					</KeepAlive>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { FORMULATE_DOCUMENTS_STATUSES } from '~/utils/dictionaries';

export default {
	name: 'PaymentDocuments',
	components: {
		DocumentsEducation: () => import('~/components/panels/formulate/components/documents-new/documentsEducation.vue'),
		DocumentsPassport: () => import('~/components/panels/formulate/components/documents-new/documentsPassport.vue'),
		DocumentChangeFIO: () => import('~/components/panels/formulate/components/documents-new/documentChangeFIO.vue'),
		DocumentsSnils: () => import('~/components/panels/formulate/components/documents-new/documentsSnils.vue'),
	},
	inject: ['isProfile'],
	props: {
		withVerification: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		...mapGetters('scenarios/paymentForm', ['baseForm', 'isRequiredVat']),
		documents() {
			const { documents } = this.baseForm;
			return documents || {};
		},
	},
	methods: {
		getVerification(type) {
			if (!this.withVerification) return false;
			return this.documents[type]?.verification_status === FORMULATE_DOCUMENTS_STATUSES.ACCEPTED;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/dev/order.scss";

.rotate-chevron {
	transform: rotate(180deg);
}

.documents-title {
	color: $blue;
	font-size: 1.2rem;
	font-weight: bold;
}

.education-info {
	cursor: pointer;
	width: 1.5rem;
    height: 1.5rem;
    font-size: 0.8rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
	padding: 0.2rem;
	background-color: #ACB5C7;
	color: white;

	.icon-icon_info {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 2px;
	}
}
</style>

<style lang="scss">
#education-diploma-info {
	.modal-header {
		border-bottom: none !important;
	}

	.modal-footer {
		border-top: none !important;
	}
}

.disabled {
	opacity: .6;
	pointer-events: none;
}
</style>
